<template>
    <div class="container-fluid">
        <div class="herosection"
            :style="{
                backgroundImage: image ? `url('${image}')` : `url('${require('@/assets/images/HeroBg.png')}')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                height: '924px'
            }"
        >
            <NavbarSection />
            <div class="heroWriteup">
                <p v-html="description"></p>
            </div>
        </div>
        <DestinationSection />
        <OurStory />
        <OurValues />
        <div class="pioneers-section" v-if="dataList.length">
            <h2>Our Pioneers</h2>
            <p>Honoring the visionaries who laid the foundation of our club.</p>
            <ImageSlider v-if="dataList.length" :people="formattedPeople" />
            <div v-else>Loading...</div>
        </div>
        <div class="pioneers-section" v-if="dataList2.length">
            <h2>Past Presidents</h2>
            <p>Celebrating the leaders who have guided us through the years.</p>
            <ImageSlider v-if="dataList2.length" :people="formattedPeople2" />
            <div v-else>Loading...</div>
        </div>
        <div class="pioneers-section" v-if="dataList3.length">
            <h2>Board of Trustees</h2>
            <p>Safeguarding our traditions and future growth.</p>
            <ImageSlider v-if="dataList3.length" :people="formattedPeople3" />
            <div v-else>Loading...</div>
        </div>
        <div class="pioneers-section" v-if="dataList4.length">
            <h2>Current Executive Committee</h2>
            <p>Leading the club today with passion and purpose.</p>
            <ImageSlider v-if="dataList4.length" :people="formattedPeople4" />
            <div v-else>Loading...</div>
        </div>
        <ContactUs />
        <FooterSection />
    </div>
</template>

<script setup>
import FooterSection from '@/components/FooterSection.vue';
import DestinationSection from '@/components/AboutComponents/DestinationSection.vue';
import OurStory from '@/components/AboutComponents/OurStory.vue';
import OurValues from '@/components/AboutComponents/OurValues.vue';
import NavbarSection from '@/components/NavbarSection.vue';
import ImageSlider from '../components/AboutComponents/ImageSlider.vue';
import ContactUs from '@/components/AboutComponents/ContactUs.vue';
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import axios from 'axios';


const aboutList = ref([]);
const bannerList = ref([]);
const image = ref('');
const title = ref('');
const description = ref('');
const dataList = ref([]);
const dataList2 = ref([]);
const dataList3 = ref([]);
const dataList4 = ref([]);

let base_url = process.env.VUE_APP_BASE_LIVE_URL

onMounted( async () => {
  await listBanner()
  await listPioneers();
  await listPastPresident();
  await listCurrentExecutives();
  await listBoardOfTrustees();
  await listRecords();
});

onBeforeUnmount( async () => {
  
});

// Format data for ImageSlider
const formattedPeople = computed(() =>
  dataList.value.map(person => ({
    name: person.fullname,
    position: person.title,
    about: person.about,
    image: `${base_url}/${person.photo}`
  }))
)

const formattedPeople2 = computed(() =>
  dataList2.value.map(person => ({
    name: person.fullname,
    position: person.title,
    about: person.about,
    image: `${base_url}/${person.photo}`
  }))
)

const formattedPeople3 = computed(() =>
  dataList3.value.map(person => ({
    name: person.fullname,
    position: person.title,
    about: person.about,
    image: `${base_url}/${person.photo}`
  }))
)

const formattedPeople4 = computed(() =>
  dataList4.value.map(person => ({
    name: person.fullname,
    position: person.title,
    about: person.about,
    image: `${base_url}/${person.photo}`
  }))
)

// Action methods

const listBanner = async () => {
  try {
    const config = 'aboutus';
    const response = await axios.get(`/website_banner_listing.php?id=${config}`, { });
    bannerList.value = response.data.data;
    title.value = bannerList.value.title
    description.value = bannerList.value.description
    image.value = `${base_url}${bannerList.value.banner_image}`
    //console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const listPioneers = async () => {
  try {
    const response = await axios.get('/pioneers_list.php', { });
    if (response.data.status) dataList.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const listPastPresident = async () => {
  try {
    const response = await axios.get('/past_presidents_list.php', { });
    if (response.data.status) dataList2.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const listBoardOfTrustees = async () => {
  try {
    const response = await axios.get('/boardof_trustees_list.php', { });
    if (response.data.status) dataList3.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const listCurrentExecutives = async () => {
  try {
    const response = await axios.get('/current_executives_list.php', { });
    if (response.data.status) dataList4.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const listRecords = async () => {
  try {
    const response = await axios.get('/about_list.php', { });
    if (response.data.status) aboutList.value = response.data.data;
    else console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};


</script>


<style lang="scss" scoped>
.herosection {
    border-radius: 20px;
    background-image: url('../assets/images/herobackground.png');
    background-size: cover;
    height: 764px;
    padding: 10px;
    position: relative;
    width: 100%;
    overflow: hidden;
    //padding:1.5rem 4rem 0 4rem;
}


.herosection::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 20px;
    background-color: rgba(8, 34, 20, 0.5);
    /* black with 40% opacity */
    z-index: 1;
}

.herosection>* {
    position: relative;
    z-index: 2;
    /* keep content above the overlay */
}
.heroWriteup,
NavbarSection {
    position: relative;
    z-index: 2;
    /* ensures text and navbar appear above overlay */
}

.heroWriteup {
        position: absolute;
        max-width: 650px;
        text-align: left;
        bottom: 15%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: center;
        align-items: center;
        color: white;

        h2 {
            font-size: 52px;
            font-weight: 700;
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }

        p {
            font-size: 18px;
            font-weight: 500;
            font-family: "Open Runde", sans-serif;
            text-align: center;

        }
    }

.pioneers-section {
    margin-top: 5rem;

    h2 {
        font-size: 48px;
        font-weight: 700;
        font-family: "Open Runde", sans-serif;
        text-align: center;
    }

    p {
        font-size: 20px;
        font-weight: 500;
        font-family: "Open Runde", sans-serif;
        text-align: center;
        margin-bottom: 4rem;
    }
}

@media (max-width: 768px) {
    .herosection {
        border-radius: 20px;
        background-image: url('../assets/images/HeroBg.png');
        background-size: cover;
        height: 624px;
        padding: 10px;
        position: relative;
        width: 100%;

        .heroWriteup {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
            text-align: center;
            display: flex;
            flex-direction: column;
            gap: 10px;
            justify-content: center;
            align-items: center;
            color: white;

            h2 {
                font-size: 32px;
                /* shrink a bit for small screens */
                font-weight: 700;
                font-family: "Open Runde", sans-serif;
            }

            p {
                font-size: 16px;
                font-weight: 500;
                font-family: "Open Runde", sans-serif;
            }
        }

        .authbuttons {
            display: flex;
            flex-direction: column;
            gap: 1rem;

            .login {
                background-color: #ffffff;
                border: 2px solid #0000001f;
                color: black;
                border-radius: 30px;
                font-family: "Open Runde", sans-serif;
                font-size: 16px;
                padding: 10px 20px;
                cursor: pointer;
                transition: 0.3s ease;
            }

            .login:hover {
                border: 2px solid #ed4e24;
            }

            .register {
                background-color: #ed4e24;
                border: 2px solid #0000001f;
                color: white;
                border-radius: 30px;
                font-family: "Open Runde", sans-serif;
                font-size: 16px;
                padding: 10px 20px;
                cursor: pointer;
                transition: 0.3s ease;
            }

            .register:hover {
                background-color: #c63d1c;
            }
        }

    }
}
</style>
